<template>
  
  <b-navbar id="navbar" toggleable="md" type="dark" variant="info">

  <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

  <b-navbar-brand href="/"><img src="assets/legiox-logo.png" class="img-responsive" alt="" style="margin-top:-6px; height: 40px;"></b-navbar-brand>

  <b-collapse is-nav id="nav_collapse">

    <b-navbar-nav>
      <router-link to="/nosotros" v-show="!auth">Nosotros</router-link>
      <b-nav-item-dropdown right v-show="!auth">
        <!-- Using button-content slot -->
        <template slot="button-content">
          Servicios
        </template>
        <router-link to="/asesorias">Asesorias</router-link>
        <router-link to="/capacitaciones">Capacitaciones</router-link>
      </b-nav-item-dropdown>
      <router-link to="/contactenos" v-show="!auth" >Contactenos</router-link>
    </b-navbar-nav>
     <b-navbar-nav class="ml-auto">
      <router-link to="/dashboard" ><span style="color: white !important;" >Generador de Documentos</span></router-link>
    </b-navbar-nav>
    <!-- Right aligned nav items -->
    <b-navbar-nav class="ml-auto">

      <!-- <router-link v-if="!auth" to="/signup" style="padding-right: 10px;">Registrarse</router-link> -->
      <router-link v-if="!auth" to="/signin">Login</router-link>
      <b-nav-item-dropdown v-if="auth"  right>
        <!-- Using button-content slot -->
        <template slot="button-content">
          <b-avatar variant="primary" :text="initials"></b-avatar>
        </template>
        <a v-if="auth" @click="onLogout" class="userOption">Logout</a>
      </b-nav-item-dropdown>
    </b-navbar-nav>

  </b-collapse>
</b-navbar>
</template>

<script>
export default {
  computed: {
    auth() {
      return this.$store.getters.isAuthenticated;
    },
    initials(){
      if(!this.$store.getters.userInfo)
        return '..';
      var nameInitial = this.$store.getters.userInfo.name.charAt(0);
      var lastnameInitial = this.$store.getters.userInfo.lastName.charAt(0);
      
      return nameInitial+lastnameInitial

    }
  },
  methods: {
    onLogout() {
      this.$store.dispatch("logout");
    }
  }
};
</script>

<style scoped>

#navbar{
  background-color: #1e2323 !important;
}

#header {
  height: 56px;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
  background-color: #1e2323;
  padding: 0 20px;
}

.logo {
  font-weight: bold;
  color: white;
}

.logo a {
  text-decoration: none;
  color: white;
}

nav {
  height: 100%;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
  height: 100%;
  display: flex;
  flex-flow: row;
  align-items: center;
}

.ul-navigation {
  list-style: none;
  margin: 0;
  padding: 0;
  height: 100%;
  display: flex;
  flex-flow: row;
  align-items: left;
}

li {
  margin: 0 16px;
}

li a {
  text-decoration: none;
  color: #000;
}

li a:hover,
li a:active,
li a.router-link-active {
  color: #fa923f;
}

.userOption{

}

.logout {
  background-color: transparent;
  border: none;
  font: inherit;
  color: white;
  cursor: pointer;
}
a{
  color:rgba(255, 255, 255, 0.5);
  text-decoration:none;
}
a:hover{
  color: rgba(255, 255, 255, 0.75);
}
.dropdown a{
  /* color: black;
  padding-left:10%;
  padding-bottom: 5%; */
      display: block;
    width: 100%;
    padding: 0.25rem 1.5rem;
    clear: both;
    font-weight: 400;
    color: #212529;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;
    border: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/header/header.vue